module.exports = __webpack_public_path__ + "static/assets/298e234a90ef1161c01bdeeb833fa142.png";